import { NgModule } from '@angular/core'
import { ClientSetupNavComponent } from './client-setup-nav.component'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    ClientSetupNavComponent
  ],
  exports: [
    ClientSetupNavComponent
  ]
})
export class ClientSetupNavComponentModule {}
